import { SagaIterator } from '@redux-saga/types';
import { all } from 'redux-saga/effects';

function* rootSaga(): SagaIterator {
  yield all([]);
}

export default rootSaga;
